import coordsPoissonnerie from '../../assets/coords_poissonnerie.json'
import coordsBoucherie from '../../assets/coords_boucherie.json'
import centrales from '../../assets/centrales.json'

// Correspondance entre la valeur d'un filtre et le libellé de l'enseigne
export const ENSEIGNE_LABELS = {
    Int: 'Intermarché',
    Sup: 'Super U',
    Lec: 'E.Leclerc',
    Car: 'Carrefour',
    Ind: 'Indépendant'
}

// Vue par défaut : France entière
export const DEFAULT_CENTER = [46.990896, 3.162845]
export const DEFAULT_ZOOM = 6

export const CONTEXT_LABELS = {
    poissonnerie: 'Poissonnerie',
    boucherie: 'Boucherie'
}

export default {
    state: {
        all: coordsPoissonnerie, // Initialiser avec les données de poissonnerie
        current:{},
        coords: coordsPoissonnerie, // Par défaut, on charge la poissonnerie
        coordsPoissonnerie: coordsPoissonnerie,
        coordsBoucherie: coordsBoucherie,
        centrales:centrales,
        zoom:false,
        zoomLevel: 6,
        centraleType:'',
        center: [ 46.990896, 	3.162845 ],
        enseigneFilter: null,
        enseigneFilters: [], // Filtres multiples d'enseignes
        context: 'poissonnerie', // 'poissonnerie' ou 'boucherie'
        viewResetToken: 0 // Incrémenté à chaque retour à la vue France, écouté par la carte
      },
    getters: {
      // Magasins réellement affichés sur la carte (contexte courant + filtres enseignes)
      filteredEnseignes (state) {
        if (!state.enseigneFilters || state.enseigneFilters.length === 0) {
          return state.all
        }
        return state.all.filter(marker =>
          state.enseigneFilters.some(filter => {
            const label = ENSEIGNE_LABELS[filter]
            return label && marker.enseigne && marker.enseigne.includes(label)
          })
        )
      },
      // Nombre de magasins par contexte
      countByContext (state) {
        return {
          poissonnerie: state.coordsPoissonnerie.length,
          boucherie: state.coordsBoucherie.length
        }
      },
      // Nombre de magasins du contexte courant (avant filtres enseignes)
      contextTotal (state) {
        return state.all.length
      },
      // Nombre total de magasins, tous contextes confondus
      totalStores (state) {
        return state.coordsPoissonnerie.length + state.coordsBoucherie.length
      }
    },
    mutations: {
      setEnseignes (state, enseignes) {
          state.all = enseignes
      },
      setCentrales (state, centrales) {
          state.centrales = centrales
      },
      setCoords (state, coords) {
          state.coords = coords
      },
      setZoom (state, bool) {
          state.zoom = bool
      },
      setCenter (state, array) {
          state.center = array
      },
      setCentraleType (state, bool) {
          state.centraleType = bool
      },
      setCurrentEnseigne (state, enseigne) {
          state.current = enseigne
      },
      setEnseigneFilter (state, enseigne) {
          state.enseigneFilter = enseigne
      },
      setEnseigneFilters (state, filters) {
          state.enseigneFilters = filters
      },
      toggleEnseigneFilter (state, enseigneVal) {
          const index = state.enseigneFilters.indexOf(enseigneVal)
          if (index > -1) {
              state.enseigneFilters.splice(index, 1)
          } else {
              state.enseigneFilters.push(enseigneVal)
          }
      },
      setZoomLevel (state, level) {
          state.zoomLevel = level
      },
      setContext (state, context) {
          state.context = context
      },
      bumpViewReset (state) {
          state.viewResetToken++
      },
    },
    actions: {
      setEnseignes ({ commit }, array) {
        commit('setEnseignes', array.sort((a,b) => a.name - b.name))
      },
      setCentrales ({ commit }, array) {
        commit('setCentrales', array.sort((a,b) => a.name - b.name))
      },
      setZoom ({ commit }, bool) {
        commit('setZoom', bool)
      },
      setCenter ({ commit }, array) {
        commit('setCenter', array)
      },
      setCurrentEnseigne ({ commit }, enseigne) {
          commit('setCurrentEnseigne', enseigne)
        },
      setCentraleType ({ commit }, bool) {
          commit('setCentraleType', bool)
      },
      setZoomLevel ({ commit }, level) {
          commit('setZoomLevel', level)
      },
      setCoords ({ commit }, coords) {
        commit('setCoords', coords)
      },
      setEnseigneFilter ({ commit }, enseigne) {
        commit('setEnseigneFilter', enseigne)
      },
      setEnseigneFilters ({ commit }, filters) {
        commit('setEnseigneFilters', filters)
      },
      // Retour à la vue France entière. La sélection est levée d'abord pour
      // qu'aucun watcher ne re-zoome sur le magasin pendant l'animation.
      resetZoom ({ commit }) {
        commit('setCurrentEnseigne', {})
        commit('setZoom', true)
        commit('setZoomLevel', DEFAULT_ZOOM)
        commit('setCenter', DEFAULT_CENTER)
        commit('bumpViewReset')
      },
      // Désélection d'un magasin : on relâche la sélection et on dézoome
      deselectEnseigne ({ dispatch }) {
        dispatch('resetZoom')
      },
      setContext ({ commit }, context) {
        commit('setContext', context)
        // Les filtres enseignes ne sont pas forcément valables d'un contexte à l'autre
        commit('setEnseigneFilters', [])
        commit('setCentraleType', '')
        // Charger les coordonnées correspondant au contexte
        const coords = context === 'poissonnerie' 
          ? coordsPoissonnerie 
          : coordsBoucherie
        commit('setCoords', coords)
        commit('setEnseignes', coords)
      }
    }
}
